import * as moment from 'moment';
import { formatDate } from '@angular/common';
import { Component, OnInit, Inject } from '@angular/core';
import { RestApiService } from 'src/app/Service/rest-api.service';
import { IFileValidationModel } from 'src/app/ViewModel/File.Model';
import { LoaderService } from 'src/app/Service/Loader/loader.service';
import { RoleFeatureModel } from 'src/app/ViewModel/RoleFeatureModel';
import { NotificationService } from 'src/app/Service/notification.service';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { ForgeViewerComponent } from '../forge-viewer/forge-viewer.component';
import { FileService, FileUploadLibrary } from 'src/app/Service/file/file.service';

@Component({
  selector: 'app-file-list',
  templateUrl: './file-list.component.html',
  styleUrls: ['./file-list.component.css']
})
export class FileListComponent implements OnInit {
  public isDeleteEnable: boolean = false;
  public fileTypeList: RoleFeatureModel[] = [];
  public fileCollection: Array<any> = new Array<any>();
  public libraries: Array<number> = new Array<number>();
  public commonFileInput: Array<IFileValidationModel> = new Array<IFileValidationModel>();

  private uris = {
    dedAgainstDEGetUrl: "DEDED/GetCommonDEDAgainstDE"
  };

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    private restApiService: RestApiService, private dialogRef: MatDialogRef<FileListComponent>, private loaderService: LoaderService,
    private dialog: MatDialog, private _fileService: FileService, private _notificationService: NotificationService) {
    if (this.data['isDeleteEnable'])
      this.isDeleteEnable = this.data['isDeleteEnable'];
  }

  ngOnInit() {
    this.getFileType();
    if (!!this.data) {
      (Array.isArray(this.data['libraryName'])) == true ? this.libraries = this.data['libraryName'] : this.libraries.push(Number(this.data['libraryName']));
      this.getFileList();
    }
    else {
      this._notificationService.showPopup("Invalid configuration", "Warning");
      this.dialogRef.close();
    }
  }

  public togglePopupDialog() {
    this.fileCollection = new Array<any>();
    this.dialogRef.close();
  }

  public getFileList() {
    let fileCount = 0;
    for (let index = 0; index < this.libraries.length; index++) {
      switch (this.libraries[index]) {
        case FileUploadLibrary.Documents:
          let fileInput_Documents = {
            projectId: this.data.projectId,
            docId: this.data.docId,
            revisionNo: this.data.revisionNo
          }

          this.commonFileInput.push({ libraryNumber: FileUploadLibrary.Documents, value: JSON.stringify(fileInput_Documents) });

          this._fileService.GetFiles({ libraryNumber: FileUploadLibrary.Documents, value: JSON.stringify(fileInput_Documents) })
            .toPromise().then((res: any[]) => {
              res.forEach((value, index) => {
                fileCount += 1;
                this.fileCollection.push({
                  serial: fileCount, fileId: value.fileId, fileName: value.fileName, fileSize: value.fileSize, fileExtension: value.fileExtension,
                  fileFullName: value.fileName + '.' + value.fileExtension, uploadedBy: value.createdBy, uploadedByName: value.createdByName, uploadedOn: this.getFormattedDate(value.createdOn),
                  fileType: value.fileType, fileTypeName: this.getFileTypeName(value.fileType), fileUrn: value.urn, isStandardDrawingDocument: value.isStandardDrawingDocument,
                  libraryNumber: FileUploadLibrary.Documents
                });
              });
            });
          break;
        case FileUploadLibrary.WorkflowDocument:
          let fileInput_WorkflowDocument = {
            projectId: this.data.projectId,
            docId: this.data.docId,
            revisionNo: this.data.revisionNo,
            task_SNo: this.data.task_SNo>=0 ? this.data.task_SNo : null,
            task_ID:this.data.task_ID?this.data.task_ID:null
          }

          this.commonFileInput.push({ libraryNumber: FileUploadLibrary.WorkflowDocument, value: JSON.stringify(fileInput_WorkflowDocument) });

          this._fileService.GetFiles({ libraryNumber: FileUploadLibrary.WorkflowDocument, value: JSON.stringify(fileInput_WorkflowDocument) })
            .toPromise().then((res: any[]) => {
              res.forEach((value, index) => {
                fileCount += 1;
                this.fileCollection.push({
                  serial: fileCount, fileId: value.fileId, fileName: value.fileName, fileSize: value.fileSize, fileExtension: value.fileExtension,
                  fileFullName: value.fileName + '.' + value.fileExtension, uploadedBy: value.createdBy, uploadedByName: value.createdByName, uploadedOn: this.getFormattedDate(value.createdOn),
                  fileType: value.fileType, fileTypeName: this.getFileTypeName(value.fileType), fileUrn: value.urn, isStandardDrawingDocument: value.isStandardDrawingDocument,
                  libraryNumber: FileUploadLibrary.WorkflowDocument
                });
              });
            });
          break;
        case FileUploadLibrary.SignedDocuments:
          let fileInput_SignedDocuments :any= {
            projectId: this.data.projectId,
            messageId: this.data.messageId,
            docId: null,
            revisionNo: null
          }
          if (!!this.data.docId) {
            fileInput_SignedDocuments.docId = this.data.docId;
          }

          if (!!this.data.revisionNo) {
            fileInput_SignedDocuments.revisionNo = this.data.revisionNo
          }

          this.commonFileInput.push({ libraryNumber: FileUploadLibrary.SignedDocuments, value: JSON.stringify(fileInput_SignedDocuments) });

          this._fileService.GetFiles({ libraryNumber: FileUploadLibrary.SignedDocuments, value: JSON.stringify(fileInput_SignedDocuments) })
            .toPromise().then((res: any[]) => {
              res.forEach((value, index) => {
                fileCount += 1;
                this.fileCollection.push({
                  serial: fileCount, fileId: value.fileId, fileName: value.fileName, fileSize: value.fileSize, fileExtension: value.fileExtension,
                  fileFullName: value.fileName + '.' + value.fileExtension, uploadedBy: value.createdBy, uploadedByName: value.createdByName, uploadedOn: this.getFormattedDate(value.createdOn),
                  fileType: value.fileType, fileTypeName: this.getFileTypeName(value.fileType), fileUrn: value.urn, isStandardDrawingDocument: value.isStandardDrawingDocument,
                  libraryNumber: FileUploadLibrary.SignedDocuments
                });
              });
            });
          break;
        case FileUploadLibrary.Communication:
          let fileInput_Communication = {
            projectId: this.data.projectId,
            messageId: this.data.messageId,
          }

          this.commonFileInput.push({ libraryNumber: FileUploadLibrary.Communication, value: JSON.stringify(fileInput_Communication) });

          this._fileService.GetFiles({ libraryNumber: FileUploadLibrary.Communication, value: JSON.stringify(fileInput_Communication) })
            .toPromise().then((res: any[]) => {
              res.forEach((value, index) => {
                fileCount += 1;
                this.fileCollection.push({
                  serial: fileCount, fileId: value.fileId, fileName: value.fileName, fileSize: value.fileSize, fileExtension: value.fileExtension,
                  fileFullName: value.fileName + '.' + value.fileExtension, uploadedBy: value.createdBy, uploadedByName: value.createdByName, uploadedOn: this.getFormattedDate(value.createdOn),
                  fileType: value.fileType, fileTypeName: this.getFileTypeName(value.fileType), fileUrn: value.urn,
                  libraryNumber: FileUploadLibrary.Communication
                });
              });
            });
          break;
        case FileUploadLibrary.CCNDocuments:
          let fileInput_CCNDocuments = {
            projectId: this.data.projectId,
            ccnId: this.data.ccnId,
            revisionNo: this.data.revisionNo
          }

          this.commonFileInput.push({ libraryNumber: FileUploadLibrary.CCNDocuments, value: JSON.stringify(fileInput_CCNDocuments) });

          this._fileService.GetFiles({ libraryNumber: FileUploadLibrary.CCNDocuments, value: JSON.stringify(fileInput_CCNDocuments) })
            .toPromise().then((res: any[]) => {
              res.forEach((value, index) => {
                fileCount += 1;
                this.fileCollection.push({
                  serial: fileCount, fileId: value.fileId, fileName: value.fileName, fileSize: value.fileSize, fileExtension: value.fileExtension,
                  fileFullName: value.fileName + '.' + value.fileExtension, uploadedBy: value.createdBy, uploadedByName: value.createdByName, uploadedOn: this.getFormattedDate(value.createdOn),
                  fileType: value.fileType, fileTypeName: this.getFileTypeName(value.fileType), fileUrn: value.urn,
                  libraryNumber: FileUploadLibrary.CCNDocuments
                });
              });
            });
          break;
      }
    }
  }

  public getFormattedDate(date: moment.MomentInput): string | void {
    if (date != null) {
      let res = (moment(date)).format('DD-MMM-yyyy');
      return res;
    }

  }

  isEmpty(input: string | any[]): boolean {
    if (!input)
      return false;
    else if (input == '')
      return false;
    else if (input.length <= 0)
      return false;
    else
      return true;
  }

  public downloadFile(dataItem: { libraryNumber: any; fileId: any; fileFullName: string; }) {
    this.loaderService.isLoading.next(true);

    this._fileService.DownloadFile({ libraryNumber: dataItem.libraryNumber, fileId: dataItem.fileId, fileName: dataItem.fileFullName }).subscribe((res: any) => {
      this.loaderService.isLoading.next(false);
      const downloadLink = document.createElement("a");
      downloadLink.href = window.URL.createObjectURL(res);
      downloadLink.download = dataItem.fileFullName;
      downloadLink.click();
      document.body.removeChild(downloadLink);
    }, err => {
      this.loaderService.isLoading.next(false);
      this._notificationService.showToast("Error in downloading attachment, try after some time", "Warning");
    })
  }

  downloadAll_OnClick() {
    let zipFileName = this.isEmpty(this.data.documentNo) == false ? formatDate(new Date(), 'dd-MMM-yyyy_HH-MM-SS', 'en-US') : this.data.documentNo;
    this.loaderService.isLoading.next(true);
    this._fileService.DownloadAllFiles(this.commonFileInput).subscribe((data: any) => {
      this.loaderService.isLoading.next(false);
      const downloadLink = document.createElement("a");
      downloadLink.href = window.URL.createObjectURL(data);
      downloadLink.download = zipFileName + ".zip";
      downloadLink.click();
      document.body.removeChild(downloadLink);
    }, error => {
      this.loaderService.isLoading.next(false);
      this._notificationService.showToast("Error in downloading attachment, try after some time", "Warning");
    });
  }

  public viewFile(dataItem: { fileUrn: any; libraryNumber: any; fileId: any; fileFullName: any; }) {
    if (!!dataItem.fileUrn) {
      let dialogRef = this.dialog.open(ForgeViewerComponent, {
        panelClass: 'mat-dialog-primary',
        width: '900px',
        data: dataItem
      });
    }
    else {
      this._fileService.DownloadFile({ libraryNumber: dataItem.libraryNumber, fileId: dataItem.fileId, fileName: dataItem.fileFullName }).subscribe((res: any) => {
        this.loaderService.isLoading.next(false);
        const downloadLink = document.createElement("a");
        downloadLink.href = window.URL.createObjectURL(res);
        downloadLink.target = "_blank";
        downloadLink.click();
        document.body.removeChild(downloadLink);
      }, err => {
        this.loaderService.isLoading.next(false);
        this._notificationService.showToast("Error in viewing attachment, try after some time", "Warning");
      })
    }
  }

  public getFileType() {
    let reqData = { "DEDescription": "File Type" };
    return this.restApiService.new_POST(this.uris.dedAgainstDEGetUrl, reqData).subscribe(data => {
      this.fileTypeList = data;
    });
  }

  public getFileTypeName(fileType: number) {
    if (this.fileTypeList.filter(item => item.dedId == fileType).length > 0)
      return this.fileTypeList.filter(item => item.dedId == fileType)[0]["dedDescription"];
    else
      return '';
  }

  public deleteFile(dataItem: { libraryNumber: any; fileId: any; fileFullName: any; }) {
    this._notificationService.showPopup('Are you sure to delete', 'Confirm').then(data => {
      if (data == 'yes') {
        this._fileService.DeleteFile({ libraryNumber: dataItem.libraryNumber, fileId: dataItem.fileId, fileName: dataItem.fileFullName }).subscribe(data => {

          this.fileCollection.forEach((item, index) => {
            if (item === dataItem) this.fileCollection.splice(index, 1);
          });

          if (data["successCode"] === 200) {
            this._notificationService.showToast(data["successMessage"], "Success");
          }
          else {
            this._notificationService.showToast(data["successMessage"], "Warning");
          }
        });
      }
    });
  }

  public isAllowedBrowserView(dataItem:any) {
    if (!!dataItem.fileUrn) return true;
    else {
      switch (dataItem.fileFullName.split('.').pop().toLowerCase()) {
        case 'pdf': case "jpg": case "jpeg": case "png": case "gif": case 'txt': case 'txt': {
          return true;
        }
        default: {
          return false;
        }
      }
    }
  }
}